import { render } from "./SectionsDetail.vue?vue&type=template&id=12072ad1"
import script from "./SectionsDetail.vue?vue&type=script&lang=js"
export * from "./SectionsDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__